import { HttpClient, HttpStatusCode } from '@/data/protocols/http'
import { AccessDeniedError, ResultWithoutRecordsError, UnexpectedError } from '@/domain/errors'
import { OpenDanfe, OpenDanfeParams } from '@/domain/usecases'
import { DocumentOpener } from '@/data/protocols/document-opener'

export class RemoteOpenDanfe implements OpenDanfe {
  constructor (
    private readonly url: string,
    private readonly httpGetClient: HttpClient<string>,
    private readonly documentOpener: DocumentOpener
  ) {}

  async open (params: OpenDanfeParams): Promise<void> {
    return await this.documentOpener.open(async () => {
      const { body, statusCode } = await this.httpGetClient.request({
        url: `${this.url}/api/portal/gerar-danfe`,
        method: 'post',
        body: params
      })

      switch (statusCode) {
        case HttpStatusCode.ok:
          if (!body) {
            throw new ResultWithoutRecordsError()
          }
          return `/${OpenDanfe.RN.FOLDER_DEFAULT_PDF_DANFE}/${params.cliCodigo}/${body}`
        case HttpStatusCode.unauthorized: throw new AccessDeniedError()
        default: throw new UnexpectedError()
      }
    })
  }
}
